/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     通用配置数据管理
  +--------------------------------------------------------------------------------------
*/

const commonStore = {
  state: {
    collapse: localStorage.getItem('__COLLAPSE__') && localStorage.getItem('__COLLAPSE__') != 0 ? 1 : 0, // Frame展开
    pindexChange: false,
    psize: Number(localStorage.getItem('__PSIZE__')) || 10,
    defaultAvatar: 'this.src="' + require('@/assets/default-avatar.png') + '"',
    defaultEquipAvatar: 'this.src="' + require('@/assets/default-equip-avatar.png') + '"',
    noPic: 'this.src="' + require('@/assets/no-pic.png') + '"',
    fileUploadUrl: process.env.VUE_APP_API_HOST + '?c=utility&a=file&do=upload',
    defaultConsoleTitle: 'AIoT 平台',
    defaultGroupId: '',
    asst_imgurl: '',
  },

  mutations: {
    SET_PSIZE: (state, val) => {
      localStorage.setItem('__PSIZE__', val || 10)
      state.psize = val || 10
    },

    SET_PINDEX_CHANGE: (state, val) => {
      state.pindexChange = val
    },

    SET_COLLAPSE: (state, val) => {
      localStorage.setItem("__COLLAPSE__", val || 0);
      state.collapse = val || 0;
    },

    SET_GROUPID: (state, val) => {
      state.defaultGroupId = val;
    },

    SET_ASST_IMGURL: (state, val) => {
      state.asst_imgurl = val;
    },
  },

  actions: {
  }
}

export default commonStore
